import { render } from "./KontaktPage.vue?vue&type=template&id=596d720a"
import script from "./KontaktPage.vue?vue&type=script&lang=js"
export * from "./KontaktPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__